module.exports = __webpack_public_path__ + "static/media/de_add_to_apple_wallet.1fb87e32.svg";